import { useEffect } from "react";

export function useCheckVersion(interval = 500000) {
  useEffect(() => {
    const checkForUpdate = async () => {
      try {
        const res = await fetch(`/version.json?v=${Date.now()}`, { cache: "no-cache" });
        if (!res.ok) return;

        const { version } = await res.json();
        const savedVersion = localStorage.getItem("app_version");

        if (!savedVersion) {
          localStorage.setItem("app_version", version);
        } else if (savedVersion !== version) {
          localStorage.setItem("app_version", version);
          window.location.href = window.location.pathname + `?v=${version}`;
        }
      } catch (error) {
        throw error;
      }
    };

    checkForUpdate();

    const intervalId = setInterval(checkForUpdate, interval);

    if (window.location.search.includes("v=")) {
      const url = new URL(window.location.href);
      url.searchParams.delete("v");
      window.history.replaceState(null, "", url.toString());
    }

    return () => clearInterval(intervalId);
  }, [interval]);
}
